import { render, staticRenderFns } from "./CaseDeleteLogs.vue?vue&type=template&id=4ed76694&"
import script from "./CaseDeleteLogs.vue?vue&type=script&lang=js&"
export * from "./CaseDeleteLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports